import React from 'react'
import styles from './image-panel.module.css'
import Image from 'gatsby-image'
import { useStaticQuery, graphql } from 'gatsby'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'

const settings = {
  dots: false,
  arrows: false,
  infinite: true,
  speed: 1000,
  // slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  variableWidth: true,
  // centerMode: true,
}

const ImagePanel = () => {
  const data = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          extension: { regex: "/(jpg)|(png)|(jpeg)/" }
          relativeDirectory: { eq: "energy-logos" }
        }
      ) {
        edges {
          node {
            base
            name
            childImageSharp {
              sizes(maxWidth: 250) {
                ...GatsbyImageSharpSizes_noBase64
              }
            }
          }
        }
      }
    }
  `)
  
  return (
    <div className={styles.wrapper}>
      <Slider {...settings} className={styles.slider}>
        {data.allFile.edges.map(({ node }) => {
          return (
            <div key={node.base}>
              <Image
                fluid={node.childImageSharp.sizes}
                className={styles.image}
                fadeIn={false}
                alt={node.name}
              ></Image>
            </div>
          )
        })} 
      </Slider>
    </div>
  )
}

export default ImagePanel

